import axiosHandler from "../../Intersepter/axiosInstance";

export const addMoneyToWallet = async (payload) => {
    try {
      const response = await axiosHandler.post(`/wallet/add-money`, payload);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  };


// Function to fetch wallet data
export const fetchWalletDataFromAPI = async (userId) => {
   try {
    const response = await axiosHandler.get(`/wallet/${userId}`);
    return response.data; 
   } catch (error) {
    throw error.response?.data || error.message;
   }
  };